import React, { useMemo } from "react";
import {
  filterData,
  FinancialTimingFilterProps,
} from "../../../Data/courseFilterData";
import { useCourses } from "../../../context/CourseContext";

const RangeField = ({
  label,
  value,
  onChange,
  min,
  max,
  unit = "",
  prefix = "",
  step = 1,
}: {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  unit?: string;
  prefix?: string;
  step?: number;
}) => (
  <div className="flex flex-col gap-2 p-2">
    <div className="flex justify-between items-center">
      <label htmlFor={label.toLowerCase().replace(/\s+/g, "-")}>{label}</label>
      <span className="text-sm text-blue-600 font-medium">
        {prefix}
        {value.toLocaleString()}
        {unit}
      </span>
    </div>
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => onChange(parseInt(e.target.value))}
      className="flex-1 accent-blue-500"
    />
  </div>
);

export default function FinancialTimingFilter(
  props: FinancialTimingFilterProps,
) {
  const {
    feeBudget,
    setFeeBudget,
    fullTimeDuration,
    setFullTimeDuration,
    paymentSchemes,
    setPaymentSchemes,
    paymentSchemesOptions,
    intakeMonth,
    setIntakeMonth,
    intakeMonthOptions,
    partTimeOption,
    setPartTimeOption,
    partTimeOptions,
    durationAbroad,
    setDurationAbroad,
    durationAbroadOptions,
    maxFee,
    maxDuration,
  } = props;

  React.useEffect(() => {
    if (feeBudget > maxFee) {
      setFeeBudget(maxFee);
    }
  }, [maxFee, feeBudget, setFeeBudget]);

  React.useEffect(() => {
    if (fullTimeDuration > maxDuration) {
      setFullTimeDuration(maxDuration);
    }
  }, [maxDuration, fullTimeDuration, setFullTimeDuration]);

  return (
    <form
      action=""
      className="grid grid-cols-1 lg:grid-cols-3 gap-2 md:gap-4 text-sm mx-6 lg:mx-0 lg:w-3/4"
    >
      <div className="order-1">
        <RangeField
          label="Fee Budget"
          value={feeBudget}
          onChange={setFeeBudget}
          min={0}
          max={maxFee}
          prefix="RM "
          step={1000}
        />
      </div>

      {/* Temporarily hidden: paymentSchemes filter uses course-listing fetch */}
      {/* <div className="flex flex-col gap-2 border-2 border-gray-200 rounded shadow-md p-2 order-3 lg:order-2">
        <label htmlFor="paymentSchemes">
          {filterData.financials.paymentSchemes.label}
        </label>
        <select
          name="paymentSchemes"
          id="paymentSchemes"
          value={paymentSchemes}
          onChange={(e) => setPaymentSchemes(e.target.value)}
        >
          {paymentSchemesOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div> */}

      <div className="flex flex-col gap-2 border-2 border-gray-200 rounded shadow-md p-2 order-4 lg:order-3">
        <label htmlFor="intakeMonth">
          {filterData.financials.intakeMonth.label}
        </label>
        <select
          name="intakeMonth"
          id="intakeMonth"
          value={intakeMonth}
          onChange={(e) => setIntakeMonth(e.target.value)}
        >
          {intakeMonthOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="order-2 lg:order-4">
        <RangeField
          label="Full Time Duration"
          value={fullTimeDuration}
          onChange={setFullTimeDuration}
          min={0}
          max={maxDuration}
          unit=" years"
        />
      </div>

      <div className="flex flex-col gap-2 border-2 border-gray-200 rounded shadow-md p-2 order-3">
        <label htmlFor="partTimeOption">
          {filterData.financials.partTimeOption.label}
        </label>
        <select
          name="partTimeOption"
          id="partTimeOption"
          value={partTimeOption}
          onChange={(e) => setPartTimeOption(e.target.value)}
        >
          {partTimeOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-col gap-2 border-2 border-gray-200 rounded shadow-md p-2 order-6">
        <label htmlFor="durationAbroad">
          {filterData.financials.durationAbroad.label}
        </label>
        <select
          name="durationAbroad"
          id="durationAbroad"
          value={durationAbroad}
          onChange={(e) => setDurationAbroad(e.target.value)}
        >
          {durationAbroadOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </form>
  );
}
